import { render } from "./DashboardTargetAccomplished.vue?vue&type=template&id=46ac4068&scoped=true&ts=true"
import script from "./DashboardTargetAccomplished.vue?vue&type=script&lang=ts"
export * from "./DashboardTargetAccomplished.vue?vue&type=script&lang=ts"

import "./DashboardTargetAccomplished.vue?vue&type=style&index=0&id=46ac4068&lang=scss&scoped=true"

import exportComponent from "/home/node/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46ac4068"]])

export default __exports__